// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-radio-group {
    display: flex;
    flex-direction: column;
    margin: 15px 0;
  }

  .mat-form-field{
    width: 100%;
  }
  
  .example-radio-button {
    margin: 5px;
  }
  
  .checkbox-slides {
    margin-top: 15px;
  }
  
  #SinglePageView .example-radio-group {
    display: flex;
    flex-direction: row;
    margin: 0;
  }
  
  #SinglePageView .form-group {
    margin: 0;
  }
  .location{width: 300px !important;}
  
  .submit-btn{
    width: 130px; 
  }
  @media(max-width:375px){
    .submit-btn{
      width: 80px; 
    }
  }
.example-month-picker .mat-calendar-period-button {
  pointer-events: none;
}

.example-month-picker .mat-calendar-arrow {
  display: none;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV4dGVybmFsLXRlc3QtdXBsb2FkLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxhQUFhO0lBQ2Isc0JBQXNCO0lBQ3RCLGNBQWM7RUFDaEI7O0VBRUE7SUFDRSxXQUFXO0VBQ2I7O0VBRUE7SUFDRSxXQUFXO0VBQ2I7O0VBRUE7SUFDRSxnQkFBZ0I7RUFDbEI7O0VBRUE7SUFDRSxhQUFhO0lBQ2IsbUJBQW1CO0lBQ25CLFNBQVM7RUFDWDs7RUFFQTtJQUNFLFNBQVM7RUFDWDtFQUNBLFVBQVUsdUJBQXVCLENBQUM7O0VBRWxDO0lBQ0UsWUFBWTtFQUNkO0VBQ0E7SUFDRTtNQUNFLFdBQVc7SUFDYjtFQUNGO0FBQ0Y7RUFDRSxvQkFBb0I7QUFDdEI7O0FBRUE7RUFDRSxhQUFhO0FBQ2YiLCJmaWxlIjoiZXh0ZXJuYWwtdGVzdC11cGxvYWQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5leGFtcGxlLXJhZGlvLWdyb3VwIHtcclxuICAgIGRpc3BsYXk6IGZsZXg7XHJcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xyXG4gICAgbWFyZ2luOiAxNXB4IDA7XHJcbiAgfVxyXG5cclxuICAubWF0LWZvcm0tZmllbGR7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICB9XHJcbiAgXHJcbiAgLmV4YW1wbGUtcmFkaW8tYnV0dG9uIHtcclxuICAgIG1hcmdpbjogNXB4O1xyXG4gIH1cclxuICBcclxuICAuY2hlY2tib3gtc2xpZGVzIHtcclxuICAgIG1hcmdpbi10b3A6IDE1cHg7XHJcbiAgfVxyXG4gIFxyXG4gICNTaW5nbGVQYWdlVmlldyAuZXhhbXBsZS1yYWRpby1ncm91cCB7XHJcbiAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcclxuICAgIG1hcmdpbjogMDtcclxuICB9XHJcbiAgXHJcbiAgI1NpbmdsZVBhZ2VWaWV3IC5mb3JtLWdyb3VwIHtcclxuICAgIG1hcmdpbjogMDtcclxuICB9XHJcbiAgLmxvY2F0aW9ue3dpZHRoOiAzMDBweCAhaW1wb3J0YW50O31cclxuICBcclxuICAuc3VibWl0LWJ0bntcclxuICAgIHdpZHRoOiAxMzBweDsgXHJcbiAgfVxyXG4gIEBtZWRpYShtYXgtd2lkdGg6Mzc1cHgpe1xyXG4gICAgLnN1Ym1pdC1idG57XHJcbiAgICAgIHdpZHRoOiA4MHB4OyBcclxuICAgIH1cclxuICB9XHJcbi5leGFtcGxlLW1vbnRoLXBpY2tlciAubWF0LWNhbGVuZGFyLXBlcmlvZC1idXR0b24ge1xyXG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xyXG59XHJcblxyXG4uZXhhbXBsZS1tb250aC1waWNrZXIgLm1hdC1jYWxlbmRhci1hcnJvdyB7XHJcbiAgZGlzcGxheTogbm9uZTtcclxufVxyXG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/external-test-upload/external-test-upload.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;EACA,UAAU,uBAAuB,CAAC;;EAElC;IACE,YAAY;EACd;EACA;IACE;MACE,WAAW;IACb;EACF;AACF;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,gtDAAgtD","sourcesContent":[".example-radio-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 15px 0;\r\n  }\r\n\r\n  .mat-form-field{\r\n    width: 100%;\r\n  }\r\n  \r\n  .example-radio-button {\r\n    margin: 5px;\r\n  }\r\n  \r\n  .checkbox-slides {\r\n    margin-top: 15px;\r\n  }\r\n  \r\n  #SinglePageView .example-radio-group {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 0;\r\n  }\r\n  \r\n  #SinglePageView .form-group {\r\n    margin: 0;\r\n  }\r\n  .location{width: 300px !important;}\r\n  \r\n  .submit-btn{\r\n    width: 130px; \r\n  }\r\n  @media(max-width:375px){\r\n    .submit-btn{\r\n      width: 80px; \r\n    }\r\n  }\r\n.example-month-picker .mat-calendar-period-button {\r\n  pointer-events: none;\r\n}\r\n\r\n.example-month-picker .mat-calendar-arrow {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
